import React, { FC } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Skeleton } from "@mui/material";

import { TableSkeleton } from "@components/common";
import { Box, Divider, Grid, Stack, Typography } from "@components/base";

const DatasetComparisonSkeleton: FC = () => {
  const { t } = useTranslation();

  return (
    <Box display="flex" flexDirection="column" flex={1} height="100%">
      <Grid size={12} position="sticky">
        <Typography fontWeight={500} variant="h6">
          <Trans
            i18nKey="csob.datasetComparison.title"
            components={{
              strong: <Typography component="span" fontSize={20} fontWeight={700} />,
            }}
          />
        </Typography>
        <Stack direction="row" spacing={2} alignItems="center" padding={1.5}>
          <Typography fontWeight={500}>
            {t("csob.datasetComparison.conditionBar.info.label1")}
          </Typography>
          <Skeleton width={50} variant="text" />
          <Divider orientation="vertical" flexItem />
          <Typography fontWeight={500}>
            {t("csob.datasetComparison.conditionBar.info.label2")}
          </Typography>
          <Skeleton width={50} variant="text" />
          <Divider orientation="vertical" flexItem />
          <Typography fontWeight={500}>
            {t("csob.datasetComparison.conditionBar.info.label3")}
          </Typography>
          <Skeleton width={50} variant="text" />
          <Divider orientation="vertical" flexItem />
          <Typography fontWeight={500}>
            {t("csob.datasetComparison.conditionBar.info.label4")}
          </Typography>
          <Skeleton width={50} variant="text" />
        </Stack>
        <TableSkeleton rows={6} columns={3} />
      </Grid>
    </Box>
  );
};

export default DatasetComparisonSkeleton;
